import React from 'react';
import Popup from 'reactjs-popup'; 
import CompleteView from './Complete/Complete_Popup';

const Complete_Popup = ({ _WaveformView }) => {
  return (
    <Popup
      open={_WaveformView.state.isShowComplete}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowComplete: false });
      }}
      contentStyle={{}}
    >
       <CompleteView _WaveformView={_WaveformView} />
    </Popup>
  );
};

export default Complete_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/Complete_Popup.js